module.exports = __webpack_public_path__ + "img/pcmap.5fece521.png";